import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, pick } from 'ramda'
import React from 'react'

import { compliancesClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useNonCompliancesCounterState = () => React.useContext(Context)
export const useNonCompliancesCounter = () => useNonCompliancesCounterState()?.nonCompliancesCount
export const useAllNonCompliancesCounter = () => useNonCompliancesCounterState()?.all

const QUERY = gql`
  query NonCompliancesCount($filter: NonComplianceFilter, $fixedFilter: NonComplianceFilter) {
    nonCompliancesCount(filter: $filter)
    all: nonCompliancesCount(filter: $fixedFilter)
  }
`

const NonCompliancesCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const { ignoreDate, statuses, origins } = widget?.data || {}
  const { date, ...manualFilter } = pick(
    ['date', 'checklistIds', 'placeIds', 'placeLevelIds'],
    useCleanFilterForRequest() || {}
  )
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: { ...fullFilter, insertedAt, statuses, origins },
      fixedFilter: { ...manualFilter, insertedAt, origins }
    },
    client: compliancesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default NonCompliancesCounterLoader
